import { itx } from "../../../src/translationItx/itx";
import { Eye } from "lucide-react";
import { useRef, type ReactNode } from "react";
import c1_state from "../model/C1_State";
import { useOnChangeWatcher } from "../../../src/models/useOnChangeWatcher";

type ViewOption = {value: "design" | "technical" | "din"; label: string};
const viewOptions: readonly ViewOption[] = [{value: "design", get label() { return itx("c1.ui.Design", "Design"); }}, {value: "technical", get label() { return itx("c1.ui.Technisch", "Technisch"); }}, {value: "din", label: "DIN"}];

export function C1_UiModeSelect({renderButton}: {
  renderButton?: (option: ViewOption & {active: boolean; select: () => void}) => ReactNode;
} = {}) {
  useOnChangeWatcher(c1_state.project.displayMode);
  const selectRef = useRef<HTMLSelectElement>(null);

  if (renderButton) {
    const buttons = viewOptions.map(option => renderButton({...option,
      active: c1_state.project.displayMode.value === option.value,
      select: () => { c1_state.project.displayMode.value = option.value; },
    }));
    return <>{buttons}</>;
  }
  const options = viewOptions.map(option => <option key={option.value} value={option.value}>{option.label}</option>);

  return (
    <label
      className="C1_uiModeSelect"
      onPointerDown={(event) => {
        if ((event.target as Element).closest("select")) return;
        event.preventDefault();
        selectRef.current?.showPicker();
      }}
    >
      <span className="C1_uiModeSelectControl">
        <Eye aria-hidden="true" />
        <select
          ref={selectRef}
          tabIndex={-1}
          value={c1_state.project.displayMode.value}
          title={itx("c1.ui.Ansicht_wechseln", "Ansicht wechseln")}
          aria-label={itx("c1.ui.Ansicht_wechseln", "Ansicht wechseln")}
          onChange={(event) => {
            c1_state.project.displayMode.value = event.target.value as "design" | "technical" | "din";
          }}
        >
          {options}
        </select>
      </span>
      <span className="C1_uiModeSelectText">{itx("menuBar.view", "Ansicht")}</span>
    </label>
  );
}
